import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@freighthub/silhouette-core'
import { useObserver } from 'mobx-react-lite'
import { FC, FormEvent } from 'react'
import { useI18n } from 'utils/localisation'

interface BookingTemplateNameDialogProps {
  closeDialog: () => void
  save: () => void
  isValid: boolean
  templateName: string
  setTemplateName: (templateName: string) => void
  errorMessage: string
  isLoading: boolean
}

export const BookingTemplateNameDialog: FC<BookingTemplateNameDialogProps> = ({
  save,
  closeDialog,
  isValid,
  templateName,
  setTemplateName,
  errorMessage,
  isLoading,
}) => {
  const { translate } = useI18n()

  const handleClose = () => {
    closeDialog()
  }

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    event.stopPropagation() // prevent parent forms from being submitted

    if (!isValid) {
      return
    }

    save()
  }

  return useObserver(() => (
    <Dialog open onClose={handleClose}>
      <form onSubmit={handleSubmit}>
        <DialogTitle showClose onClose={handleClose}>
          {translate('booking_templates_name_dialog-title')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{translate('booking_templates_name_dialog-note')}</DialogContentText>
          <TextField
            value={templateName}
            onChange={(event) => setTemplateName(event.target.value)}
            label={translate('booking_templates_name_dialog-name_label')}
            placeholder={translate('booking_templates_name_dialog-name_placeholder')}
            fullWidth
            required
            error={!!errorMessage}
            helperText={!!errorMessage && translate(errorMessage)}
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{translate('booking_templates_name_dialog-cancel')}</Button>
          <Button type="submit" variant="contained">
            {isLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              translate('booking_templates_name_dialog-save')
            )}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  ))
}
